var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "14",
        "height": "14",
        "viewBox": "0 0 20 20",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('path', {
      attrs: {
        "d": "M18.725 4.411L17.11 8.535l-.269.688a.368.368 0 01-.479.208l-.687-.268-4.125-1.617a.369.369 0 01-.209-.479l.269-.687a.368.368 0 01.479-.209l3.416 1.339c-.988-2.43-3.351-4.154-6.135-4.154a6.644 6.644 0 000 13.288 6.64 6.64 0 006.258-4.429h1.548c-.965 3.406-4.09 5.905-7.806 5.905A8.12 8.12 0 011.25 10a8.12 8.12 0 018.12-8.12 8.101 8.101 0 017.109 4.216l.871-2.224a.368.368 0 01.479-.208l.687.268a.371.371 0 01.209.48z",
        "fill": "currentColor",
        "fill-rule": "nonzero"
      }
    })]));
  }
};